var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "reports-view" },
    [
      _c("HeaderControlsReport", {
        ref: "headerControlsReport",
        on: {
          reportTypeChanged: _vm.setReportType,
          reportGenerated: _vm.renderGraphs,
          reportFilterUpdated: _vm.filterUpdate
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container-fluid fixed-top-bar-padding report-wrapper" },
        [
          _c("div", { staticClass: "deliverable-header" }, [
            _c("h2", { staticClass: "d-flex d-md-inline" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("span", [
                _vm._v("\n          Reports\n          "),
                _c(
                  "span",
                  { staticClass: "report-title d-block d-md-inline" },
                  [
                    _c(
                      "span",
                      { staticClass: "text-primary d-none d-md-inline" },
                      [_vm._v(">")]
                    ),
                    _vm._v(" " + _vm._s(_vm.reportType.name))
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showReport,
                  expression: "showReport"
                }
              ],
              staticClass: "report-graphs"
            },
            [
              _c("div", { staticClass: "report-header" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-md-5 stats-border breakpoint__fix"
                    },
                    [
                      _c("div", { staticClass: "report-stats" }, [
                        _c("span", [
                          _c("span", { staticClass: "stats-number" }, [
                            _vm._v(_vm._s(_vm.totalCalls))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "stats-name" }, [
                            _vm._v(" Calls")
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.reportType.id != "fullList"
                          ? _c("span", { staticClass: "stats-name-wrap" }, [
                              _c("span", { staticClass: "stats-number" }, [
                                _vm._v(_vm._s(_vm.totalDataType))
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "stats-name" }, [
                                _vm._v(" " + _vm._s(_vm.reportDataType)),
                                _vm.totalDataType > 1
                                  ? _c("span", [_vm._v("s")])
                                  : _vm._e()
                              ])
                            ])
                          : _vm._e()
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-md-7 controls text-center text-lg-right breakpoint__fix"
                    },
                    [
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.noData,
                              expression: "!noData"
                            }
                          ],
                          staticClass: "btn btn-theme mr-2",
                          class: !_vm.filterQuery.filterByDateCreated
                            ? "margin-15"
                            : "",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              return _vm.exportReport("excel")
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              class: _vm.filterQuery.filterByDateCreated
                                ? "download-text"
                                : ""
                            },
                            [_vm._v("Download Excel")]
                          ),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "fas fa-file-excel text-primary"
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.noData,
                              expression: "!noData"
                            }
                          ],
                          staticClass: "btn btn-theme mr-2",
                          class: !_vm.filterQuery.filterByDateCreated
                            ? "margin-15"
                            : "",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              return _vm.exportReport("pdf")
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              class: _vm.filterQuery.filterByDateCreated
                                ? "download-text"
                                : ""
                            },
                            [_vm._v("Download PDF")]
                          ),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "fas fa-file-pdf text-primary"
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.filterQuery.filterByDateCreated,
                              expression: "filterQuery.filterByDateCreated"
                            }
                          ],
                          staticClass: "date-shifter"
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "prev",
                              attrs: { variant: "theme" },
                              on: {
                                click: function($event) {
                                  return _vm.prevDate()
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-chevron-left" })]
                          ),
                          _c("span", { staticClass: "date-holder" }, [
                            _vm._v(
                              _vm._s(
                                _vm.filterQuery.dateCreatedRange
                                  ? _vm
                                      .$moment(
                                        _vm.filterQuery.dateCreatedRange
                                          .startDate
                                      )
                                      .format("MMM DD")
                                  : ""
                              ) +
                                " - " +
                                _vm._s(
                                  _vm.filterQuery.dateCreatedRange
                                    ? _vm
                                        .$moment(
                                          _vm.filterQuery.dateCreatedRange
                                            .endDate
                                        )
                                        .format("MMM DD")
                                    : ""
                                )
                            )
                          ]),
                          _c(
                            "b-button",
                            {
                              staticClass: "next",
                              attrs: { variant: "theme" },
                              on: {
                                click: function($event) {
                                  return _vm.nextDate()
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-chevron-right" })]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.reportType.id == "fullList"
                ? _c("perfect-scrollbar", [_c("div", { ref: "reportData" })])
                : _c("div", { ref: "reportData" })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "media-call-icon" }, [
      _c("img", {
        attrs: { src: require("@/csmworkflow/img/report-icon.svg") }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }